import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import { showLoading, hideLoading } from '../../../../store/app';
import { toastr } from '../../../../components/CustomToast';
import WebAPIClient, {
  errorResponseToastr,
} from '../../../../api/_energytracer';

const FILTER_OPTIONS = [
  { 'key': 'organization_id', 'name': 'Organization ID' },
  { 'key': 'building_id', 'name': 'Building ID' },
  { 'key': 'climate_zone', 'name': 'Climate Zone' },
  { 'key': 'none', 'name': 'No filter (all)' }
]

export default function CreateBenchmarks() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const [endDate, setEndDate] = useState('2025-12-31');
  const [buildingType, setBuildingType] = useState('education');
  const [filterType, setFilterType] = useState('organization_id');
  const [filterValue, setFilterValue] = useState('');
  const [submitDisabled1, setSubmitDisabled1] = useState(false);

  const [endDate2, setEndDate2] = useState('2025-12-31');
  const [buildingType2, setBuildingType2] = useState('education');
  const [regionType, setRegionType] = useState('climate_zone');
  const [regionValue, setRegionValue] = useState('5A');

  const handleLoading = (loading) => {
    if (loading) {
      setIsLoading(true);
      dispatch(showLoading());
    } else {
      setIsLoading(false);
      dispatch(hideLoading());
    }
  };

  useEffect(() => {
    if (buildingType === '' || endDate === '') {
      setSubmitDisabled1(true)
    }
    else if (filterType !== 'none' && filterValue === '') {
      setSubmitDisabled1(true)
    }
    else {
      setSubmitDisabled1(false)
    }
  }, [endDate, buildingType, filterType, filterValue])


  const triggerBenchmarking = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/trigger_benchmarking';
    let filters = [{ 'name': 'building_type', value: buildingType }]

    if (filterType !== 'none') {
      filters.push({ 'name': filterType, value: filterValue })

    }
    let payload = { 'end_date': endDate, 'filters': filters }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Benchmarking Triggered',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };


  const generateStatistics = async () => {
    handleLoading(true);
    let url = 'veregy_benchmarking/generate_statistics';
    let payload = { 'end_date': endDate2, 'building_type': buildingType2, 'region_type': regionType, 'region_value': regionValue }

    try {
      await new WebAPIClient().POST(url, payload);
      toastr.success({
        title: 'Statistics Triggered',
      });
    } catch (err) {
      errorResponseToastr(err);
    } finally {
      handleLoading(false);
      dispatch(hideLoading());
    }
  };

  return <div>
    <h3>Trigger Benchmarking</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`End Date (YYYY-MM-DD)`}
            value={endDate ? endDate : ''}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Building Type`}
            value={buildingType ? buildingType : ''}
            onChange={(e) => setBuildingType(e.target.value)}
          />
        </ListItem>
        <ListItem disableGutters>
          <FormControl id='filter' variant='standard' fullWidth>
            <InputLabel id='filter-label'>Filter Option</InputLabel>
            <Select
              labelId='filter-label'
              name='filter'
              onChange={(e) => {
                setFilterType(e.target.value);
              }}
              value={filterType}
              MenuProps={{
                MenuListProps: { disablePadding: true },
                slotProps: {
                  paper: { sx: { minWidth: 'unset !important' } },
                },
              }}
              sx={{
                backgroundColor: 'unset',
                '& .MuiSelect-select': {
                  display: 'flex',
                  alignItems: 'center',
                },
              }}>
              <MenuItem value=''></MenuItem>
              {FILTER_OPTIONS.map((opt) => {
                return (
                  <MenuItem key={`filter-${opt.key}`} value={opt.key}>
                    {opt.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Filter Value`}
            value={filterValue ? filterValue : ''}
            onChange={(e) => setFilterValue(e.target.value)}
          />
        </ListItem>


        <Button
          type='submit'
          onClick={triggerBenchmarking}
          color='primary'
          variant='contained'
          disabled={
            !endDate ||
            isLoading || submitDisabled1
          }>
          Submit
        </Button>
      </List>
    </form>
    <br></br>
    <h3>Generate Statistics</h3>
    <form>
      <List disablePadding>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`End Date (YYYY-MM-DD)`}
            value={endDate2 ? endDate2 : ''}
            onChange={(e) => setEndDate2(e.target.value)}
          />
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Building Type`}
            value={buildingType2 ? buildingType2 : ''}
            onChange={(e) => setBuildingType2(e.target.value)}
          />
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Region Type`}
            value={regionType ? regionType : ''}
            onChange={(e) => setRegionType(e.target.value)}
          />
        </ListItem>
        <ListItem disableGutters>
          <TextField
            fullWidth
            variant='standard'
            id='value'
            label={`Region Value`}
            value={regionValue ? regionValue : ''}
            onChange={(e) => setRegionValue(e.target.value)}
          />
        </ListItem>

        <Button
          type='submit'
          onClick={generateStatistics}
          color='primary'
          variant='contained'
          disabled={
            !endDate ||
            isLoading
          }>
          Submit
        </Button>
      </List>
    </form>
  </div>
}